export const PRODUCT = 'WELDING INSPECTION VISUAL ATLAS™'

export const PRODUCT_TAGLINE =
  'THE COMPLETE PROFESSIONAL WELD INSPECTION & DEFECT IDENTIFICATION VISUAL SYSTEM'

/** Anchor id of the $27 purchase section */
export const OFFER_ANCHOR = '#offer'

export const CHECKOUT_URL = 'https://welding-inspection-visual-atlas.impultienda.ar/checkout'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/oMhZnEdHDRPUAfEcXUC1Hn/Diseno_sin_titulo-5.png'

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export const PIXEL_ID = '1733329941053749'
